var $5d3aeb5a18a0b757$exports = {};
$5d3aeb5a18a0b757$exports = {
    "maximum": `Najve\u{10D}ji`,
    "minimum": `Najmanj`
};


export {$5d3aeb5a18a0b757$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
